<template>
  <a-modal
          title="抽样项目详情"
          okText="确定"
          cancelText="取消"
          width="1200px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="项目名称" prop="prjName">
            <a-input v-model="formState.prjName"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="牵头单位" prop="leaderName">
            <a-input v-model="formState.leaderName"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="监测品类" prop="hangye">
            <a-input v-model="formState.hangye"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="项目开始时间" prop="startDate">
            <a-input v-model="formState.startDate"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="项目结束时间" prop="endDate">
            <a-input v-model="formState.endDate"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="监测环节" prop="monitLink">
            <a-ext-monit-link-check-group v-model="formState.monitLink"></a-ext-monit-link-check-group>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}"  prop="monitTaskRegion">
            <a-ext-check-target-picker-province v-model="formState.monitTaskRegion"></a-ext-check-target-picker-province>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}" prop="monitProduce">
            <a-ext-pin-zhong-and-bad-select v-model="formState.monitProduce"></a-ext-pin-zhong-and-bad-select>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtMonitLinkCheckGroup from '../../../components/AntDesignExt/All/AExtMonitLinkCheckGroup'
import AExtCheckTargetPickerProvince from '../../../components/AntDesignExt/All/AExtCheckTargetPickerProvince'
import AExtPinZhongAndBadSelect from '../../../components/AntDesignExt/All/AExtPinZhongAndBadSelect'
import {addorUpdateMonitTask as saveApi,getMonitTaskById as initApi} from '../../../api/api'

export default {
    name: "FormModel",
    components:{
        AExtMonitLinkCheckGroup,AExtCheckTargetPickerProvince,AExtPinZhongAndBadSelect,},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                prj_name:'',
                leader_name:'',
                hangye:'',
                start_date:'',
                end_date:'',
                monit_link:'',
                monit_task_region:'',
                monit_produce:'',
            },
            rules: {

            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("projectDetailModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>